module.exports = __webpack_public_path__ + "media/marketing_area/events-20f0ba1c.png";